import { render } from "./FinalEvaluation.vue?vue&type=template&id=2711f6e6&scoped=true"
import script from "./FinalEvaluation.vue?vue&type=script&lang=js"
export * from "./FinalEvaluation.vue?vue&type=script&lang=js"

import "./final-evaluation.scss?vue&type=style&index=0&id=2711f6e6&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2711f6e6"]])

export default __exports__